<!--  -->
<template>
  <div class="un_member_user">
    <UserInfo>
      <div class="top_main_info un_member_bg">
        <div class="avatar avatar_cinema" @click="show=true"></div>
        <div class="un_vip_user" @click="show=true">
          <div class="un_vip_name">{{userName}}</div>
        </div>
      </div>
    </UserInfo>
    <HomeNav></HomeNav>
    <div class="mb" @click="show=false" v-if="show">
      <div class="pannel">
        <div class="avatar"></div>
        <div class="vip_name">{{userName}}</div>
        <div class="btn" @click="exit">退出登录</div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeNav from "../components/HomeNav";
import UserInfo from "../components/UserInfo";
import {Toast} from "vant";
export default {
  name: "UnMemberUser",
  beforeRouteEnter(to,from,next){
    //判断用户身份是否正确 非会员 为 0
    if(localStorage.getItem("identity")==0){
      next(true)
    }else{
      localStorage.removeItem("identity");
      localStorage.removeItem("userName");
      localStorage.removeItem("token");
      next("/cinemaLogin");
    }
  },
  created() {
    if(localStorage.getItem("userName")&&localStorage.getItem("token")){
      this.userName=localStorage.getItem("userName");
    }else{
      // 未在缓存里找到用户信息，提示用户需要重新登录
      Toast({message:"请重新登录",icon:"cross"})
      this.$router.push("/cinemaLogin")
    }
  },
  data () {
    return {
      userName:'',
      show:false
    }
  },
  components:{
    UserInfo,HomeNav
  },
  methods:{
    exit(){
      Toast.success({message:"退出登录"})
      localStorage.removeItem("identity");
      localStorage.removeItem("userName");
      localStorage.removeItem("token");
      this.$router.push("/cinemaLogin");
    }
  }
}
</script>

<style scoped>
.mb {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.36);
  box-shadow: 0px 2px 7px 3px rgba(112, 112, 112, 0.06);
}
.mb .pannel {
  width: 614px;
  height: 546px;
  background: #FFFFFF;
  box-shadow: 0px 4px 13px 5px rgba(112, 112, 112, 0.06);
  border-radius: 53px;
  border: 1px solid rgba(0, 0, 0, 0.03);
  position: absolute;
  top: 336px;
  left: 68px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mb .pannel .avatar {
  margin-top: 93px;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-image: url("../assets/avatar_cinema.png");
  background-size: 120px;
  background-position: 0 0;
  background-repeat: no-repeat;
}
.mb .pannel .vip_name {
  margin: 10px 0 123px;
  font-size: 32px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 45px;
}
.mb .pannel .btn {
  width: 375px;
  height: 81px;
  background: #5A77FD;
  border-radius: 41px;
  opacity: 0.87;
  font-size: 32px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #FFFFFF;
  line-height: 81px;
  text-align: center;
}
</style>
